import * as ActionTypes from './index';
import {actionCreator} from "../helpers/functions";

export const getProductsLabels = actionCreator(ActionTypes.GET_PRODUCTS_LABELS);
export const getProductsLabelsSuccess = actionCreator(ActionTypes.GET_PRODUCTS_LABELS_SUCCESS);
export const getProductsLabelsFailed = actionCreator(ActionTypes.GET_PRODUCTS_LABELS_FAILED);
export const countProductsLabels = actionCreator(ActionTypes.COUNT_PRODUCTS_LABELS);
export const countProductsLabelsSuccess = actionCreator(ActionTypes.COUNT_PRODUCTS_LABELS_SUCCESS);
export const countProductsLabelsFailed = actionCreator(ActionTypes.COUNT_PRODUCTS_LABELS_FAILED);
export const changeLabelPreferences = actionCreator(ActionTypes.CHANGE_LABELS_PREFERENCES);
export const changeLabelsOrder = actionCreator(ActionTypes.CHANGE_LABELS_ORDER);
export const createLabel = actionCreator(ActionTypes.CREATE_LABEL);
export const createLabelSuccess = actionCreator(ActionTypes.CREATE_LABEL_SUCCESS);
export const createLabelFailed = actionCreator(ActionTypes.CREATE_LABEL_FAILED);
export const deleteLabel = actionCreator(ActionTypes.DELETE_LABEL);
export const editLabel = actionCreator(ActionTypes.EDIT_LABEL);
export const editLabelSuccess = actionCreator(ActionTypes.EDIT_LABEL_SUCCESS);
export const editLabelFailed = actionCreator(ActionTypes.EDIT_LABEL_FAILED);
export const editLabelField = actionCreator(ActionTypes.EDIT_LABEL_FIELD);
export const copyLabelForEdit = actionCreator(ActionTypes.COPY_LABEL_FOR_EDIT);
export const clearProductLabelDeleteErrorMessage = actionCreator(ActionTypes.CLEAR_PRODUCT_LABEL_DELETE_ERROR_MESSAGE);
export const deleteLabelSuccess = actionCreator(ActionTypes.DELETE_LABEL_SUCCESS);
export const deleteLabelFailed = actionCreator(ActionTypes.DELETE_LABEL_FAILED);
export const clearProductsLabelsForm = actionCreator(ActionTypes.CLEAR_PRODUCTS_LABELS_FORM);
export const clearTempUploadedProductLabel = actionCreator(ActionTypes.CLEAR_TEMP_UPLOADED_PRODUCT_LABEL);
export const storeTemporaryProductLabelImage = actionCreator(ActionTypes.STORE_TEMPORARY_PRODUCT_LABEL_IMAGE);
export const tempNewProductAddProductLabel = actionCreator(ActionTypes.TEMP_NEW_PRODUCT_ADD_PRODUCT_LABEL);
export const editProductLabel = actionCreator(ActionTypes.EDIT_PRODUCT_LABEL);



// WEBPACK FOOTER //
// ./src/actions/productLabels.js